
import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

import { CLIENT_SUCCESS_MAILTO } from 'constants/contacts';

import Icons from 'assets/icons';

import {
  EXTEND_WITH_PRODUCT_LABEL,
  EXTEND_WITH_UPSELL_DESCRIPTION,
} from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type { ExtendWithOption } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export interface ExtensionUpsellTileProps {
  title: string;
  type: ExtendWithOption;
  contactTestId: string;
  testId?: string;
}

const ExtensionUpsellTile = ({
  title,
  type,
  contactTestId,
  testId,
}: ExtensionUpsellTileProps) => {
  const handleContactClick = (): void => {
    window.location.href = CLIENT_SUCCESS_MAILTO;
  };

  return (
    <div
      className="flex w-full flex-col overflow-hidden rounded-lg border border-gray-200"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2 bg-gray-200 px-3 py-2">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        <Icons.Lock className="size-4 shrink-0" aria-hidden="true" />
      </div>

      <Stack sx={{ flex: '1 1 0%', bgcolor: 'common.white' }}>
        <Box
          sx={{
            px: 1.5,
            py: 1.25,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: 'tokens.gray.700',
          }}
        >
          <p className="font-semibold">
            Unlock {EXTEND_WITH_PRODUCT_LABEL[type]}.
          </p>
          <p>{EXTEND_WITH_UPSELL_DESCRIPTION[type]}</p>
        </Box>

        <Box sx={{ mt: 'auto', px: 1.5, pt: 1, pb: 1.5 }}>
          <Button
            variant="brand-filled"
            size="sm"
            className="w-full"
            onClick={handleContactClick}
            data-testid={contactTestId}
          >
            Contact Us
          </Button>
        </Box>
      </Stack>
    </div>
  );
};

export default ExtensionUpsellTile;
